import UploadList from './UploadList';
export default UploadList;
//# sourceMappingURL=index.js.map
